<template>
  <div v-if="visible" class="dual-ring-loader">
    <div :style="{ width: `${outerSize}px`, height: `${outerSize}px` }" class="dual-ring-loader__ring">
      <div
        :style="{ 'border-color': `${color} transparent`, 'border-width': borderWidth }"
        class="dual-ring-loader__inner"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DualRingLoader',
  props: {
    visible: Boolean,
    size: {
      type: Number,
      default: 46,
    },
    color: {
      type: String,
      default: '#3355EC',
    },
  },
  computed: {
    outerSize() {
      return this.size;
    },
    borderWidth() {
      return `${this.size * 0.04}px`;
    },
  },
};
</script>

<style scoped lang="scss">
@keyframes ring-inner {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.dual-ring-loader {
  display: inline-block;
  position: relative;

  &__ring {
    display: inline-block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &__inner {
    content: ' ';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    margin: 1px;
    border-radius: 50%;
    border-style: solid;
    animation: ring-inner 1.2s linear infinite;
  }
}
</style>
